import { MENU } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";
import { normalizeResponse } from "../normalizeResponse";

// Menú público (secciones activas, productos y promos activas)
export const fetchMenu = async () => {
  const response = await ApiRequestInterceptor(MENU.publico, "GET");
  return normalizeResponse(response, "No se pudo cargar el menú");
};

// Menú completo para el panel (incluye lo apagado)
export const fetchMenuAdmin = async () => {
  const response = await ApiRequestInterceptor(MENU.admin, "GET");
  return normalizeResponse(response, "No se pudo cargar el menú");
};
